import React, { useEffect, useState } from 'react';
import { baseURLPublic } from '../../config/BaseUrl';
import PatronPage from './PatronPage';

export default function PublicMedia({ match }) {
  const [state, setState] = useState({ loading: true });
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    let active = true;
    setState({ loading: true });
    baseURLPublic.get(`social-gallery-v2/media/${match.params.id}`).then(({ data }) => {
      if (active) setState({ data: data.data });
    }).catch((error) => {
      if (active) setState({ error: error.response?.status === 404 ? 'This media is unavailable.' : 'We could not load your media. Please try again.' });
    });
    return () => { active = false; };
  }, [match.params.id, retry]);
  if (state.loading) return <main className="sg-public-state" role="status">Loading your moment…</main>;
  if (state.error) return <main className="sg-public-state"><p role="alert">{state.error}</p><button type="button" onClick={() => setRetry(retry + 1)}>Try again</button></main>;
  return <PatronPage data={state.data} />;
}
